<template>
	<svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M12.3333 7.73649L9 11.0698M9 11.0698L5.66667 7.73649M9 11.0698V1.06982M16.5 11.0698V12.7365C16.5 13.657 15.7538 14.4032 14.8333 14.4032H3.16667C2.24619 14.4032 1.5 13.657 1.5 12.7365V11.0698" stroke="#16828F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
	</svg>
</template>
